import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import logger from "redux-logger";
import reducer from "./reducer";
import { rootSaga } from "./saga/index";

const sagaMiddleware = createSagaMiddleware();

export default function configureStore(initialState) {
  const middlewares = [sagaMiddleware];

  if (["localhost", "mars", "tde", "dev"].some((environmentName) => window.location.href.includes(environmentName))) {
    middlewares.push(logger);
  }

  const store = createStore(reducer, initialState, applyMiddleware(...middlewares));

  sagaMiddleware.run(rootSaga);

  return store;
}
